module.exports = __webpack_public_path__ + "static/media/ca-bobina3.e3b37529.jpg";